import type { Airflow, Shop } from '@aviata/platform-types';

export function isPromocodeModifier(
  modifier: Shop.PriceModifier.Entity,
): modifier is Shop.PriceModifier.Promocode {
  return modifier.type === 'PROMOCODE';
}

export function getActivePromocodeModifier(
  order: Airflow.Order.Entity,
  billId: string,
) {
  return order.price_modifiers
    .filter(isPromocodeModifier)
    .find(promocode => promocode.data.bill_id === billId);
}
